import {Controller} from "stimulus"

export default class extends Controller {
  static targets = [
    'container',
  ]

  connect() {
  }

  disconnect() {
  }

  start(event) {
    event.preventDefault()
    const clearEvent = new CustomEvent('clear');
    this.element.dispatchEvent(clearEvent);
    this.containerTargets.forEach(element => {
      if (element.type == 'text') {
        element.value = ''
      }
    });
  }
}
